import React from "react";
import EventDetailsForm from "./EventDetailsForm";
import EventDateTimeForm from "./EventDateTimeForm";
import EventAliasForm from "./EventAliasForm";
import { LoadingOverlay } from "./LoadingOverlay";
import {
  hasRooms,
  isRoom,
  roomLabelOf,
  roomNounOf,
} from "@/components/rooms/rooms";
import Callout from "@/components/settings/Callout";
import {
  SettingsPage,
  SettingsSection,
} from "@/components/settings/SettingsPage";
import { roomNounText } from "@/components/globalUtils";
import { t } from "@/localization";

// Title, date, time, event link and the links/files under the video.
// Title/location and links save automatically; the date and the event link
// have their own Save buttons because changing them affects guests.
const EventDetails = ({ event, prefer_multiple_tests }) => {
  // Show loading state if event data is not ready
  if (!event?.event_datetime_utc || !event?.event_timezone) {
    return <LoadingOverlay />;
  }

  const noun = roomNounText(roomNounOf(event).toLowerCase());

  // Rooms share their event's schedule: it's changed on the main one.
  const dateSection = !event.is_test && (
    <SettingsSection title={t("Date and time")} help="details.dateTime">
      {isRoom(event) ? (
        <Callout tone="info">
          {t(
            "{room} follows the main event's date, time and days. Change them there and every {noun} moves with it.",
            { room: roomLabelOf(event), noun }
          )}
        </Callout>
      ) : (
        <>
          {hasRooms(event) && (
            <Callout tone="info" style={{ marginBottom: 12 }}>
              {t(
                "Changes here apply to all {noun}s. Extra days are charged per {noun}.",
                { noun }
              )}
            </Callout>
          )}
          <EventDateTimeForm
            event={event}
            prefer_multiple_tests={prefer_multiple_tests}
          />
        </>
      )}
    </SettingsSection>
  );

  const linkSection = !event.is_test && (
    <SettingsSection title={t("Event link")} help="details.eventLink">
      <EventAliasForm event={event} />
    </SettingsSection>
  );

  return (
    <SettingsPage title={t("Event details")}>
      <EventDetailsForm
        event={event}
        prefer_multiple_tests={prefer_multiple_tests}
        middle={
          <>
            {dateSection}
            {linkSection}
          </>
        }
      />
    </SettingsPage>
  );
};

export default EventDetails;
